import React, { useState } from 'react';
import {
  Card,
  Table,
  Button,
  Input,
  Space,
  Tag,
  Modal,
  message,
  DatePicker,
  Select,
  Row,
  Col,
  Statistic,
  Tooltip,
  Descriptions,
  Timeline,
  Divider,
  Badge,
} from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,
  DownloadOutlined,
  EyeOutlined,
  FilterOutlined,
  ClockCircleOutlined,
  UserOutlined,
  SafetyOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';

const { RangePicker } = DatePicker;
const { Option } = Select;

const OperationLogs: React.FC = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filterLevel, setFilterLevel] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterUser, setFilterUser] = useState('all');
  const [dateRange, setDateRange] = useState<any>(null);

  // 模拟操作日志数据
  const logData = [
    {
      id: 1,
      timestamp: '2025-10-24 14:30:15',
      user: 'admin',
      userName: '超级管理员',
      role: 'super_admin',
      action: 'login',
      actionName: '用户登录',
      target: 'system',
      targetName: '系统',
      level: 'info',
      status: 'success',
      ip: '192.168.1.100',
      userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36',
      details: '用户成功登录系统',
      duration: 0,
      createTime: '2025-10-24 14:30:15',
    },
    {
      id: 2,
      timestamp: '2025-10-24 14:25:30',
      user: 'manager',
      userName: '系统管理员',
      role: 'admin',
      action: 'edit',
      actionName: '编辑配置',
      target: 'agent',
      targetName: '智能体配置',
      level: 'info',
      status: 'success',
      ip: '192.168.1.101',
      userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
      details: '更新智能体"客服Bot"的配置参数',
      duration: 1200,
      createTime: '2025-10-24 14:25:30',
    },
    {
      id: 3,
      timestamp: '2025-10-24 14:20:45',
      user: 'operator',
      userName: '操作员',
      role: 'operator',
      action: 'create',
      actionName: '新增话术',
      target: 'script',
      targetName: '话术管理',
      level: 'info',
      status: 'success',
      ip: '192.168.1.102',
      userAgent: 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36',
      details: '新增话术"欢迎语"，包含5个话术模板',
      duration: 800,
      createTime: '2025-10-24 14:20:45',
    },
    {
      id: 4,
      timestamp: '2025-10-24 14:15:20',
      user: 'viewer',
      userName: '查看者',
      role: 'viewer',
      action: 'view',
      actionName: '查看报表',
      target: 'reports',
      targetName: '报表管理',
      level: 'info',
      status: 'success',
      ip: '192.168.1.103',
      userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 15_0 like Mac OS X) AppleWebKit/605.1.15',
      details: '查看仪表盘数据报表',
      duration: 500,
      createTime: '2025-10-24 14:15:20',
    },
    {
      id: 5,
      timestamp: '2025-10-24 14:10:10',
      user: 'admin',
      userName: '超级管理员',
      role: 'super_admin',
      action: 'delete',
      actionName: '删除用户',
      target: 'profile',
      targetName: '用户画像',
      level: 'warning',
      status: 'success',
      ip: '192.168.1.100',
      userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36',
      details: '删除用户"user_005"的画像数据',
      duration: 2000,
      createTime: '2025-10-24 14:10:10',
    },
    {
      id: 6,
      timestamp: '2025-10-24 14:05:35',
      user: 'manager',
      userName: '系统管理员',
      role: 'admin',
      action: 'deploy',
      actionName: '部署工作流',
      target: 'workflow',
      targetName: '工作流管理',
      level: 'info',
      status: 'success',
      ip: '192.168.1.101',
      userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
      details: '部署工作流"新用户引导流程"到生产环境',
      duration: 5000,
      createTime: '2025-10-24 14:05:35',
    },
    {
      id: 7,
      timestamp: '2025-10-24 14:00:50',
      user: 'operator',
      userName: '操作员',
      role: 'operator',
      action: 'import',
      actionName: '导入数据',
      target: 'knowledge',
      targetName: '知识库管理',
      level: 'info',
      status: 'success',
      ip: '192.168.1.102',
      userAgent: 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36',
      details: '导入知识库文件"FAQ_v2.0.xlsx"，包含150条问答',
      duration: 3000,
      createTime: '2025-10-24 14:00:50',
    },
    {
      id: 8,
      timestamp: '2025-10-24 13:55:25',
      user: 'admin',
      userName: '超级管理员',
      role: 'super_admin',
      action: 'update',
      actionName: '修改设置',
      target: 'settings',
      targetName: '系统设置',
      level: 'warning',
      status: 'success',
      ip: '192.168.1.100',
      userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36',
      details: '更新会话超时时间为120分钟',
      duration: 600,
      createTime: '2025-10-24 13:55:25',
    },
    {
      id: 9,
      timestamp: '2025-10-24 13:50:15',
      user: 'test_user',
      userName: '测试用户',
      role: 'operator',
      action: 'login',
      actionName: '用户登录',
      target: 'system',
      targetName: '系统',
      level: 'error',
      status: 'failed',
      ip: '192.168.1.104',
      userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
      details: '登录失败：密码错误次数过多，账号已被锁定',
      duration: 0,
      createTime: '2025-10-24 13:50:15',
    },
    {
      id: 10,
      timestamp: '2025-10-24 13:45:40',
      user: 'manager',
      userName: '系统管理员',
      role: 'admin',
      action: 'export',
      actionName: '导出数据',
      target: 'reports',
      targetName: '报表管理',
      level: 'info',
      status: 'success',
      ip: '192.168.1.101',
      userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
      details: '导出用户行为分析报表，包含1000条记录',
      duration: 2500,
      createTime: '2025-10-24 13:45:40',
    },
  ];

  const handleViewDetail = (record: any) => {
    setSelectedRecord(record);
    setDetailModalVisible(true);
  };

  const handleRefresh = () => {
    setLoading(true);
    message.loading('正在刷新日志...', 1);
    setTimeout(() => {
      setLoading(false);
      message.success('日志刷新成功！');
    }, 1500);
  };

  const handleExport = () => {
    message.loading('正在导出日志...', 1);
    setTimeout(() => {
      message.success('日志导出成功！');
    }, 1500);
  };

  const handleBatchExport = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('请选择要导出的日志');
      return;
    }
    message.loading('正在批量导出日志...', 1);
    setTimeout(() => {
      message.success(`已导出 ${selectedRowKeys.length} 条日志`);
      setSelectedRowKeys([]);
    }, 1500);
  };

  const getLevelColor = (level: string) => {
    const colors: Record<string, string> = {
      info: 'blue',
      warning: 'orange',
      error: 'red',
      debug: 'purple',
    };
    return colors[level] || 'default';
  };

  const getLevelIcon = (level: string) => {
    const icons: Record<string, React.ReactNode> = {
      info: <CheckCircleOutlined />,
      warning: <ExclamationCircleOutlined />,
      error: <CloseCircleOutlined />,
      debug: <ClockCircleOutlined />,
    };
    return icons[level] || <ClockCircleOutlined />;
  };

  const getStatusColor = (status: string) => {
    return status === 'success' ? 'green' : 'red';
  };

  const getStatusName = (status: string) => {
    return status === 'success' ? '成功' : '失败';
  };

  const getRoleColor = (role: string) => {
    const colors: Record<string, string> = {
      super_admin: 'red',
      admin: 'blue',
      manager: 'green',
      operator: 'orange',
      viewer: 'default',
    };
    return colors[role] || 'default';
  };

  const getRoleName = (role: string) => {
    const names: Record<string, string> = {
      super_admin: '超级管理员',
      admin: '系统管理员',
      manager: '业务管理员',
      operator: '操作员',
      viewer: '查看者',
    };
    return names[role] || role;
  };

  const columns = [
    {
      title: '时间',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 150,
      sorter: (a: any, b: any) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime(),
    },
    {
      title: '用户信息',
      key: 'userInfo',
      width: 150,
      render: (_: any, record: any) => (
        <Space direction="vertical" size={0}>
          <div style={{ fontWeight: 'bold' }}>{record.userName}</div>
          <div style={{ fontSize: 12, color: '#999' }}>{record.user}</div>
          <Tag color={getRoleColor(record.role)}>
            {getRoleName(record.role)}
          </Tag>
        </Space>
      ),
    },
    {
      title: '操作信息',
      key: 'actionInfo',
      width: 200,
      render: (_: any, record: any) => (
        <Space direction="vertical" size={0}>
          <div style={{ fontWeight: 'bold' }}>{record.actionName}</div>
          <div style={{ fontSize: 12, color: '#666' }}>{record.targetName}</div>
          <div style={{ fontSize: 12, color: '#999' }}>{record.details}</div>
        </Space>
      ),
    },
    {
      title: '级别',
      key: 'level',
      width: 80,
      render: (_: any, record: any) => (
        <Tag color={getLevelColor(record.level)} icon={getLevelIcon(record.level)}>
          {record.level.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: '状态',
      key: 'status',
      width: 80,
      render: (_: any, record: any) => (
        <Tag color={getStatusColor(record.status)}>
          {getStatusName(record.status)}
        </Tag>
      ),
    },
    {
      title: '耗时',
      key: 'duration',
      width: 80,
      render: (_: any, record: any) => (
        <div style={{ textAlign: 'center' }}>
          {record.duration > 0 ? `${record.duration}ms` : '-'}
        </div>
      ),
    },
    {
      title: 'IP地址',
      dataIndex: 'ip',
      key: 'ip',
      width: 120,
    },
    {
      title: '操作',
      key: 'action',
      width: 100,
      render: (_: any, record: any) => (
        <Tooltip title="查看详情">
          <Button type="link" icon={<EyeOutlined />} onClick={() => handleViewDetail(record)}>
            详情
          </Button>
        </Tooltip>
      ),
    },
  ];

  const filteredData = logData.filter(item => {
    const matchesSearch = !searchText || 
      item.userName.toLowerCase().includes(searchText.toLowerCase()) ||
      item.actionName.toLowerCase().includes(searchText.toLowerCase()) ||
      item.targetName.toLowerCase().includes(searchText.toLowerCase()) ||
      item.details.toLowerCase().includes(searchText.toLowerCase());
    
    const matchesLevel = filterLevel === 'all' || item.level === filterLevel;
    const matchesStatus = filterStatus === 'all' || item.status === filterStatus;
    const matchesUser = filterUser === 'all' || item.user === filterUser;
    
    const matchesDate = !dateRange || (
      new Date(item.timestamp) >= dateRange[0].toDate() &&
      new Date(item.timestamp) <= dateRange[1].toDate()
    );
    
    return matchesSearch && matchesLevel && matchesStatus && matchesUser && matchesDate;
  });

  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys,
  };

  return (
    <div style={{ padding: 24 }}>
      {/* 统计卡片 */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic title="总日志数" value={logData.length} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="成功操作" value={logData.filter(item => item.status === 'success').length} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="失败操作" value={logData.filter(item => item.status === 'failed').length} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="今日日志" value={Math.floor(Math.random() * 50) + 20} />
          </Card>
        </Col>
      </Row>

      <Card
        title="操作日志"
        extra={
          <Space>
            <Button
              icon={<ReloadOutlined />}
              onClick={handleRefresh}
              loading={loading}
            >
              刷新
            </Button>
            <Button
              icon={<DownloadOutlined />}
              onClick={handleExport}
            >
              导出全部
            </Button>
            {selectedRowKeys.length > 0 && (
              <Button
                icon={<DownloadOutlined />}
                onClick={handleBatchExport}
              >
                批量导出
              </Button>
            )}
          </Space>
        }
      >
        {/* 搜索和筛选 */}
        <div style={{ marginBottom: 16 }}>
          <Space wrap>
            <Input
              placeholder="搜索用户、操作或详情"
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
            <RangePicker
              onChange={setDateRange}
              placeholder={['开始时间', '结束时间']}
            />
            <Select
              value={filterLevel}
              onChange={setFilterLevel}
              style={{ width: 120 }}
            >
              <Option value="all">全部级别</Option>
              <Option value="info">信息</Option>
              <Option value="warning">警告</Option>
              <Option value="error">错误</Option>
              <Option value="debug">调试</Option>
            </Select>
            <Select
              value={filterStatus}
              onChange={setFilterStatus}
              style={{ width: 120 }}
            >
              <Option value="all">全部状态</Option>
              <Option value="success">成功</Option>
              <Option value="failed">失败</Option>
            </Select>
            <Select
              value={filterUser}
              onChange={setFilterUser}
              style={{ width: 120 }}
            >
              <Option value="all">全部用户</Option>
              <Option value="admin">admin</Option>
              <Option value="manager">manager</Option>
              <Option value="operator">operator</Option>
              <Option value="viewer">viewer</Option>
              <Option value="test_user">test_user</Option>
            </Select>
          </Space>
        </div>

        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="id"
          rowSelection={rowSelection}
          loading={loading}
          pagination={{
            total: filteredData.length,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条记录`,
          }}
          scroll={{ x: 1000 }}
        />
      </Card>

      {/* 日志详情模态框 */}
      <Modal
        title="操作日志详情"
        open={detailModalVisible}
        onCancel={() => setDetailModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setDetailModalVisible(false)}>
            关闭
          </Button>,
        ]}
        width={800}
      >
        {selectedRecord && (
          <div>
            <Descriptions title="基本信息" bordered column={2}>
              <Descriptions.Item label="操作时间" span={2}>
                <Space>
                  <ClockCircleOutlined />
                  {selectedRecord.timestamp}
                </Space>
              </Descriptions.Item>
              <Descriptions.Item label="操作用户">
                <Space>
                  <UserOutlined />
                  {selectedRecord.userName} ({selectedRecord.user})
                </Space>
              </Descriptions.Item>
              <Descriptions.Item label="用户角色">
                <Tag color={getRoleColor(selectedRecord.role)}>
                  {getRoleName(selectedRecord.role)}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="操作类型">
                <Space>
                  {getLevelIcon(selectedRecord.level)}
                  <Tag color={getLevelColor(selectedRecord.level)}>
                    {selectedRecord.level.toUpperCase()}
                  </Tag>
                </Space>
              </Descriptions.Item>
              <Descriptions.Item label="操作状态">
                <Tag color={getStatusColor(selectedRecord.status)}>
                  {getStatusName(selectedRecord.status)}
                </Tag>
              </Descriptions.Item>
            </Descriptions>

            <Divider />

            <Descriptions title="操作详情" bordered column={1}>
              <Descriptions.Item label="操作名称">
                {selectedRecord.actionName}
              </Descriptions.Item>
              <Descriptions.Item label="目标对象">
                {selectedRecord.targetName} ({selectedRecord.target})
              </Descriptions.Item>
              <Descriptions.Item label="操作描述">
                {selectedRecord.details}
              </Descriptions.Item>
              <Descriptions.Item label="执行耗时">
                {selectedRecord.duration > 0 ? `${selectedRecord.duration}ms` : '无'}
              </Descriptions.Item>
            </Descriptions>

            <Divider />

            <Descriptions title="技术信息" bordered column={2}>
              <Descriptions.Item label="IP地址" span={2}>
                {selectedRecord.ip}
              </Descriptions.Item>
              <Descriptions.Item label="用户代理" span={2}>
                <div style={{ 
                  maxWidth: '100%', 
                  wordBreak: 'break-all',
                  fontSize: 12,
                  color: '#666'
                }}>
                  {selectedRecord.userAgent}
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="记录时间">
                {selectedRecord.createTime}
              </Descriptions.Item>
              <Descriptions.Item label="日志ID">
                #{selectedRecord.id}
              </Descriptions.Item>
            </Descriptions>

            <Divider />

            <div>
              <h4>操作时间线</h4>
              <Timeline>
                <Timeline.Item color="green">
                  <div style={{ fontWeight: 'bold' }}>操作开始</div>
                  <div style={{ fontSize: 12, color: '#666' }}>
                    {selectedRecord.timestamp} - 用户 {selectedRecord.userName} 开始执行 {selectedRecord.actionName}
                  </div>
                </Timeline.Item>
                {selectedRecord.duration > 0 && (
                  <Timeline.Item color="blue">
                    <div style={{ fontWeight: 'bold' }}>操作执行</div>
                    <div style={{ fontSize: 12, color: '#666' }}>
                      执行耗时 {selectedRecord.duration}ms
                    </div>
                  </Timeline.Item>
                )}
                <Timeline.Item color={selectedRecord.status === 'success' ? 'green' : 'red'}>
                  <div style={{ fontWeight: 'bold' }}>操作完成</div>
                  <div style={{ fontSize: 12, color: '#666' }}>
                    状态: {getStatusName(selectedRecord.status)}
                  </div>
                </Timeline.Item>
              </Timeline>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default OperationLogs;
